import {EnumUtils as NewEnumUtils, type EnumType} from '@colonist/utils'

export namespace EnumUtils {
    /**
     * @deprecated Import EnumUtils from @colonist/utils
     */
    export function loopEnums(targetEnum: EnumType, block: (element, elementNo) => void) {
        return NewEnumUtils.loopEnums(targetEnum, block)
    }

    /**
     * @deprecated Import EnumUtils from @colonist/utils
     */
    export function getEnumKey<EnumT, EnumTypeT>(enumValue: EnumT, enumType: EnumTypeT): keyof EnumTypeT {
        return NewEnumUtils.getEnumKey(enumValue, enumType)
    }
}
